import Icon1 from "@assets/icons/Icon";
import React from "react";
import { Org } from "types/org";
import {
  MemberUser,
  MemberAssignmentItem,
} from "../blocks/MemberAssignmentBlock";
import { StatusBlock } from "../blocks/Status";
import { ProjectSummary, PartnerInfos, Broadcast, EmailSent } from "types";

const projectStatusDisplay: Record<
  string,
  { label: string; type: "success" | "info" | "warning" | "error" | "default" | "step" }
> = {
  not_started: { label: "En attente", type: "default" },
  in_progress: { label: "En cours", type: "info" },
  delivered: { label: "Livré", type: "success" },
  completed: { label: "Terminé", type: "success" },
  sav: { label: "SAV", type: "warning" },
};

export type Folder = {
  id: string;
  ref?: any;
  infos: {
    general: {
      name: string;
      num: string;
      city: string;
      date?: { seconds: number };
    };
    photo_facade?: { url: string; id: string };
    commercial_id?: string;
    comptability_id?: string;
  };
  creation_date: { seconds: number };
  status: string;
  results: {
    mandatory_checks_conforme?: number;
    mandatory_checks_available?: number;
  };
  archived?: boolean;
};

export function transformProjectsToTable(
  allfolders: ProjectSummary[],
  activetab: any = "current",
  orgData: Org | null = null,
  searchValue: string = "",
  orgUsers: MemberUser[] = [],
) {
  try {
    if (searchValue !== "") {
      allfolders = allfolders.filter((folder: ProjectSummary) =>
        folder.infos.general.name.includes(searchValue),
      );
    }

    if (activetab && activetab !== "all") {
      allfolders = allfolders.filter(
        (folder: ProjectSummary) => folder.status === activetab,
      );
    }

    // Define columns for DataGrid, customize based on your data structure
    const columns = [
      { field: "id", headerName: "ID", width: 300 },
      // {
      //   field: "photo",
      //   headerName: "Photo",
      //   width: 150,
      //   renderCell: (params: any) => {
      //     const photo = params.value;
      //     if (photo) {
      //       let retryAttempted = false; // Flag to prevent infinite retries
      //       return (
      //         <img
      //           src={photo.url}
      //           onError={async (e) => {
      //             if (retryAttempted) {
      //               console.error(
      //                 "Image refresh already attempted, skipping retry"
      //               );
      //               return;
      //             }
      //             retryAttempted = true;

      //             console.error("Image failed to load, refreshing URL...");
      //             const img = e.currentTarget as HTMLImageElement | null;
      //             if (!img) return;

      //             try {
      //               const token = await getOrRefreshFirebaseToken();
      //               const new_url = await refreshFileUrl(
      //                 photo.id,
      //                 token,
      //                 prefix
      //               );
      //               img.src = new_url;
      //               let ref = getRefFromId("folder", params.row.id);
      //               updateDocDataFieldApi(
      //                 ref!,
      //                 "infos.photo_facade",
      //                 {
      //                   url: new_url,
      //                 },
      //                 prefix
      //               );
      //               rows = rows.map((row: any) => {
      //                 if (row.id === params.row.id) {
      //                   return {
      //                     ...row,
      //                     photo: { url: new_url, id: photo.id },
      //                   };
      //                 }
      //                 return row;
      //               });
      //             } catch (err) {
      //               console.error("Failed to refresh image URL", err);
      //             }
      //           }}
      //           alt="Folder Facade"
      //           className="w-32 h-16 object-cover rounded-md"
      //         />
      //       );
      //     }
      //     return (
      //       <div className="w-32 h-16 bg-gray-100 rounded-md flex items-center justify-center">
      //         <Icon1 name="image" size={20} color="grey"></Icon1>
      //       </div>
      //     );
      //   },
      // },
      // { field: "num", headerName: "Numéro", width: 100 },

      {
        field: "name",
        headerName: "Nom",
        flex: 1,
        minWidth: 180,
        renderCell: (params: any) => {
          return (
            <div
              className={`flex flex-row gap-1 items-center font-medium text-black h-6 ${
                params.row.all_blocked
                  ? "text-red-500  bg-red-100 rounded-full inline-flex  px-2 "
                  : ""
              }`}
            >
              {params.row.all_blocked && (
                <div className="">
                  <Icon1 name="warning" size={18} color="red"></Icon1>
                </div>
              )}
              {params.value}
            </div>
          );
        },
      },
      { field: "city", headerName: "Ville", width: 130 },
      {
        field: "commercial",
        headerName: "Commercial",
        width: 130,

        renderCell: (params: any) => {
          let user = params.value;
          return (
            <div className="flex flex-row gap-1 items-center">
              <MemberAssignmentItem
                currentUserId={user.id}
                memberName={user.name}
                memberColor={user.color}
                assignMemberToRole={() => {}}
                users={orgUsers}
              />
            </div>
          );
        },
      },
      {
        field: "comptability",
        headerName: "Comptabilité",
        width: 130,

        renderCell: (params: any) => {
          let user = params.value;
          return (
            <div className=" flex-row gap-1 items-center ">
              <MemberAssignmentItem
                currentUserId={user.id}
                memberName={user.name}
                memberColor={user.color}
                assignMemberToRole={() => {}}
                users={orgUsers}
              />
            </div>
          );
        },
      },
      {
        field: "creation_date",
        headerName: "Creation",
        width: 150,
        renderCell: (params: any) => {
          // Customize color based on status value
          const date_int = params.value;

          const date = new Date(date_int);
          return (
            <div>
              {date.toLocaleString("fr-FR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          );
        },
      },

      {
        field: "status",
        headerName: "Statut",
        width: 160,

        renderCell: (param: any) => {
          const status = param.value;
          const config = projectStatusDisplay[status] || {
            label: status,
            type: "default" as const,
          };
          return <StatusBlock type={config.type} label={config.label} />;
        },
      },

      // Add more columns as needed
    ];

    // Create rows from the clients array
    let rows = allfolders.map((folder: ProjectSummary, index: number) => ({
      id: folder.id || index + 1, // Use client's ID or default index
      num: folder.infos.general.num || "ddd", // Use client's number or default
      name: folder.infos.general.name?.trim() || "", // Use client's name or default 'Unknown'
      city: folder.infos.general.city || "", // Use client's type or default
      creation_date: folder.infos.general.creation_date.seconds * 1000 || 0,
      photo: folder.infos.general.photo_file?.url || "",
      status: folder.status || "ok", // Use client's status or default
      commercial:
        orgUsers.find((user) => user.id === folder.infos.team.commercial_id) ||
        {},
      comptability:
        orgUsers.find(
          (user) => user.id === folder.infos.team.comptability_id,
        ) || {},

      state: "ok", // Use client's city or default
      // Use client's city or default
    }));

    rows = rows.sort((a: any, b: any) => {
      return a.name
        .trim()
        .toLowerCase()

        .localeCompare(b.name.toLowerCase().trim());
    });

    return { rows, columns }; // Return rows and columns for the DataGrid
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

const companyTypeLabels: Record<string, string> = {
  architecte: "Architecte",
  bureau_d_etudes: "Bureau d'études",
  menuiserie: "Menuiserie",
  plomberie: "Plomberie",
  electricite: "Électricité",
  charpente: "Charpente",
  jardinage: "Jardinage",
  nettoyage: "Nettoyage",
  demenagement: "Déménagement",
  informatique: "Informatique",
  autre_btp: "Autre BTP",
  autre_service: "Autre service",
  autre: "Autre",
};

export function transformPartnersToTable(
  partners: PartnerInfos[],
  activeTab: string = "all",
  searchValue: string = "",
) {
  try {
    let filtered = partners;

    if (activeTab && activeTab !== "all") {
      filtered = filtered.filter((p) => p.company_type === activeTab);
    }

    if (searchValue !== "") {
      const search = searchValue.toLowerCase();
      filtered = filtered.filter(
        (p) =>
          p.display_name?.toLowerCase().includes(search) ||
          p.company_name?.toLowerCase().includes(search) ||
          p.role?.toLowerCase().includes(search),
      );
    }

    const columns = [
      {
        field: "company_name",
        headerName: "Entreprise",
        flex: 1,
        minWidth: 150,
        renderCell: (params: any) => (
          <div className="font-medium text-black">{params.value}</div>
        ),
      },
      { field: "display_name", headerName: "Nom", width: 180 },
      { field: "role", headerName: "Rôle", width: 150 },
      {
        field: "company_type",
        headerName: "Type",
        width: 140,
        renderCell: (params: any) => (
          <StatusBlock
            type="info"
            label={companyTypeLabels[params.value] || params.value}
          />
        ),
      },
      { field: "email", headerName: "Email", width: 200 },
      { field: "phone_number", headerName: "Téléphone", width: 140 },
    ];

    const rows = filtered
      .map((p) => ({
        id: p.id,
        display_name: p.display_name || "",
        company_name: p.company_name || "",
        role: p.role || "",
        company_type: p.company_type || "autre",
        email: p.email || p.company_email || "",
        phone_number: p.phone_number || p.company_phone || "",
      }))
      .sort((a, b) =>
        a.display_name.toLowerCase().localeCompare(b.display_name.toLowerCase()),
      );

    return { rows, columns };
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

export function transformBroadcastsToTable(
  broadcasts: Broadcast[],
  activeTab: string = "all",
  searchValue: string = "",
) {
  try {
    let filtered = broadcasts;

    if (activeTab && activeTab !== "all") {
      filtered = filtered.filter((b) => b.status === activeTab);
    }

    if (searchValue !== "") {
      const search = searchValue.toLowerCase();
      filtered = filtered.filter(
        (b) =>
          b.title?.toLowerCase().includes(search) ||
          b.content?.toLowerCase().includes(search) ||
          b.author.display_name?.toLowerCase().includes(search),
      );
    }

    const columns = [
      {
        field: "title",
        headerName: "Titre",
        flex: 1,
        minWidth: 180,
        renderCell: (params: any) => (
          <div className="font-medium text-black">{params.value}</div>
        ),
      },
      {
        field: "content",
        headerName: "Contenu",
        width: 250,
        renderCell: (params: any) => (
          <div className="text-neutral-500 truncate">
            {params.value?.length > 50
              ? params.value.slice(0, 50) + "..."
              : params.value}
          </div>
        ),
      },
      {
        field: "author",
        headerName: "Auteur",
        width: 140,
        renderCell: (params: any) => (
          <div
            className="rounded-full px-3 py-1 text-white font-medium text-h3 w-fit"
            style={{ backgroundColor: params.value?.color_tag || "#6B7280" }}
          >
            {params.value?.display_name}
          </div>
        ),
      },
      {
        field: "start_date",
        headerName: "Début",
        width: 130,
        renderCell: (params: any) => {
          const date = new Date(params.value);
          return (
            <div>
              {date.toLocaleDateString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </div>
          );
        },
      },
      {
        field: "end_date",
        headerName: "Fin",
        width: 130,
        renderCell: (params: any) => {
          const date = new Date(params.value);
          return (
            <div>
              {date.toLocaleDateString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </div>
          );
        },
      },
      {
        field: "status",
        headerName: "État",
        width: 120,
        renderCell: (params: any) => (
          <StatusBlock
            type={params.value === "active" ? "success" : "default"}
            label={params.value === "active" ? "Active" : "Inactive"}
          />
        ),
      },
    ];

    const rows = filtered
      .map((b) => ({
        id: b.id,
        title: b.title || "",
        content: b.content || "",
        author: b.author,
        start_date: b.start_date.seconds * 1000,
        end_date: b.end_date.seconds * 1000,
        status: b.status,
      }))
      .sort((a, b) => b.start_date - a.start_date);

    return { rows, columns };
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}

export function transformEmailsSentToTable(
  sentEmails: EmailSent[],
  projects: ProjectSummary[],
  searchValue: string = "",
) {
  try {
    let filtered = sentEmails;

    if (searchValue !== "") {
      const search = searchValue.toLowerCase();
      filtered = filtered.filter((e) => {
        const projectName =
          projects
            .find((p) => p.id === e.project_id)
            ?.infos.general.name?.toLowerCase() || "";
        return (
          e.subject?.toLowerCase().includes(search) ||
          e.emails_to?.some((addr) => addr.toLowerCase().includes(search)) ||
          projectName.includes(search)
        );
      });
    }

    const columns = [
      {
        field: "subject",
        headerName: "Sujet",
        flex: 1,
        minWidth: 180,
        renderCell: (params: any) => (
          <div className="font-medium text-black truncate">{params.value}</div>
        ),
      },
      {
        field: "recipients",
        headerName: "Destinataires",
        width: 200,
        renderCell: (params: any) => (
          <div className="text-neutral-500 truncate">{params.value}</div>
        ),
      },
      { field: "project_name", headerName: "Projet", width: 150 },
      {
        field: "date",
        headerName: "Date",
        width: 150,
        renderCell: (params: any) => {
          const date = new Date(params.value);
          return (
            <div>
              {date.toLocaleDateString("fr-FR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}{" "}
              {date.toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          );
        },
      },
    ];

    const rows = filtered
      .map((e) => ({
        id: e.id,
        subject: e.subject || "",
        recipients: e.emails_to?.join(", ") || "",
        project_name:
          projects.find((p) => p.id === e.project_id)?.infos.general.name || "",
        date: e.created_at.seconds * 1000,
      }))
      .sort((a, b) => b.date - a.date);

    return { rows, columns };
  } catch (e) {
    console.error(e);
    return { rows: [], columns: [] };
  }
}
